import { MouseEventHandler, useCallback, useContext, useRef, useState } from 'react'
import useStyles from './styles'
import { MultiPaneLayoutContext } from '../multipPaneLayout.context'

export type PaneDividerProps = {
    paneId: number,
    index: number,
    vertical: boolean,
    thickness: number
}

const PaneDivider: React.FC<PaneDividerProps> = ({ paneId, index, vertical, thickness }) => {
    const { classes, cx } = useStyles()
    const layoutContext = useContext(MultiPaneLayoutContext)
    const [dragActive, setDragActive] = useState(false)
    const previousCoordinates = useRef({
        x: -1,
        y: -1
    })

    const pane = layoutContext.panesConfig[paneId]

    const mouseMoveListener = useCallback((event: any) => {
        if (previousCoordinates.current.x == -1 || previousCoordinates.current.y == -1) return

        const deltaX = vertical ? event.clientX - previousCoordinates.current.x : 0
        const deltaY = vertical ? 0 : event.clientY - previousCoordinates.current.y
        layoutContext.onPaneResize(paneId, index, deltaX, deltaY)

    }, [pane, index, layoutContext.onPaneResize])

    const onMouseDown: MouseEventHandler<HTMLDivElement> = useCallback((event) => {
        previousCoordinates.current.x = event.clientX
        previousCoordinates.current.y = event.clientY

        layoutContext.onPaneResizeStart()
        setDragActive(true)
        const mouseUpListener = () => {
            document.removeEventListener('mousemove', mouseMoveListener)
            document.removeEventListener('mouseup', mouseUpListener)
            layoutContext.onPaneResizeStop()
            setDragActive(false)
        }
        document.addEventListener('mouseup', mouseUpListener)
        document.addEventListener('mousemove', mouseMoveListener)
    }, [layoutContext])
    return <div
        className={cx(classes.container, {
            [classes.vertical]: vertical,
            [classes.horizontal]: !vertical,
            [classes.hovered]: dragActive
        })}
        style={{
            width: vertical ? `${thickness}px` : '100%',
            height: vertical ? '100%' : `${thickness}px`
        }}
        onMouseDown={onMouseDown}
    />
}

export default PaneDivider